function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M444 256c-5 13-65 149-80 184-16 36-48 72-106 72H157c-61 0-93-36-93-100V136c0-37 51-35 51-2v121c0 10 18 10 18 0V60c0-38 56-37 56 0v184c0 10 17 10 17 0V28c0-37 56-38 56 0v219c0 9 18 10 18 0V63c0-35 61-36 61 0v208c0 13 13 15 18 5 4-9 23-51 23-51 19-39 82-15 62 31z"
}));